(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    if ($('.featured-product-section') && $('.featured-product-section').length > 0) {
      
      document.querySelectorAll(".featured-product-section .product__media-list").forEach((elem, index) => {
        var slider = new Flickity(elem, {
          pageDots: false,
          prevNextButtons: false,
          adaptiveHeight: true,
          wrapAround: true,
          on: {
            select: function (index) {
              let slides = $(".featured-product-section .product__media-list .product__media-item");
    
              var iframe = $(slides[index]).find("iframe");
    
              var allIframes = document.querySelectorAll(".featured-product-section .product__media-list iframe");
              //var allIframes = $(".featured-product-section .product__media-list").find("iframe");
              var video = $(slides[index]).find("video");
              var allVideos = $(".featured-product-section .product__media-list").find("video");
    
              if (video && video.length > 0) {
                video.get(0).play();
              } else if (allVideos && allVideos.length > 0) {
                allVideos.get(0).pause();
              }
    
              if (iframe && iframe.length > 0) {
                iframe[0].contentWindow.postMessage(
                  JSON.stringify({ event: "command", func: "playVideo" }),
                  "*",
                );
              } else if (allIframes && allIframes.length > 0) {
                allIframes.forEach(video => {
                  if (video.classList.contains('js-youtube')) {
                    video.contentWindow.postMessage(
                      JSON.stringify({ event: "command", func: "pauseVideo" }),
                      "*",
                    );
                  }
                  else {
                    video.contentWindow.postMessage('{"method":"pause"}', "*");
                  }
                })
              } else {
                return false;
              }
            },
          },
        });

        elem.parentElement.querySelector('.featured-product-section .product__media-list-wrapper-outer-arrow_prev').addEventListener( 'click', function() {
          slider.previous();
        });
        elem.parentElement.querySelector('.featured-product-section .product__media-list-wrapper-outer-arrow_next').addEventListener( 'click', function() {
          slider.next();
        });
      });

      document.querySelectorAll(".featured-product-section .product__media-sublist").forEach((elem, index) => {
        var slider = new Flickity(elem, {
          asNavFor: $(".featured-product-section .product__media-list")[index],
          contain: true,
          pageDots: false,
          prevNextButtons: false,
          cellAlign: "left",
        })
      });
    }
  })

  document.addEventListener("shopify:section:load", function () {
     if (document.querySelectorAll('.featured-product-section').length > 0) {
      let $flickityElems = document.querySelectorAll(".featured-product-section .product__media-list.flickity-enabled");
      $flickityElems.forEach(($elem) => {
        Flickity.data($elem).destroy();
      });

      document.querySelectorAll(".featured-product-section .product__media-list").forEach((elem, index) => {
        var slider = new Flickity(elem, {
          pageDots: false,
          prevNextButtons: false,
          adaptiveHeight: true,
          wrapAround: true,
          on: {
            select: function (index) {
              let slides = $(".featured-product-section .product__media-list .product__media-item");
    
              var iframe = $(slides[index]).find("iframe");
    
              var allIframes = document.querySelectorAll(".featured-product-section .product__media-list iframe");
              //var allIframes = $(".featured-product-section .product__media-list").find("iframe");
              var video = $(slides[index]).find("video");
              var allVideos = $(".featured-product-section .product__media-list").find("video");
    
              if (video && video.length > 0) {
                video.get(0).play();
              } else if (allVideos && allVideos.length > 0) {
                allVideos.get(0).pause();
              }
    
              if (iframe && iframe.length > 0) {
                iframe[0].contentWindow.postMessage(
                  JSON.stringify({ event: "command", func: "playVideo" }),
                  "*",
                );
              } else if (allIframes && allIframes.length > 0) {
                allIframes.forEach(video => {
                  if (video.classList.contains('js-youtube')) {
                    video.contentWindow.postMessage(
                      JSON.stringify({ event: "command", func: "pauseVideo" }),
                      "*",
                    );
                  }
                  else {
                    video.contentWindow.postMessage('{"method":"pause"}', "*");
                  }
                })
              } else {
                return false;
              }
            },
          },
        });

        elem.parentElement.querySelector('.featured-product-section .product__media-list-wrapper-outer-arrow_prev').addEventListener( 'click', function() {
          slider.previous();
        });
        elem.parentElement.querySelector('.featured-product-section .product__media-list-wrapper-outer-arrow_next').addEventListener( 'click', function() {
          slider.next();
        });
      });

      document.querySelectorAll(".featured-product-section .product__media-sublist").forEach((elem, index) => {
        var slider = new Flickity(elem, {
          asNavFor: $(".featured-product-section .product__media-list")[index],
          contain: true,
          pageDots: false,
          prevNextButtons: false,
          cellAlign: "left",
        })
      });
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.querySelector('.shopify-section-header');
this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
this.headerBounds = {};
this.currentScrollTop = 0;
this.preventReveal = false;

if (this.headerIsAlwaysSticky) {
this.header.classList.add('shopify-section-header-sticky');
};

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;
this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
} else {
window.clearTimeout(this.isScrolling);

this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);

requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
requestAnimationFrame(this.reset.bind(this));
}

this.currentScrollTop = scrollTop;
}

hide() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
this.closeSearchModal();
}

reveal() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}

reset() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}

closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
this.disclosures.forEach(disclosure => disclosure.close());
}

closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
}
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('change', debounce((event) => {
			const body = JSON.stringify({note: event.target.value});
			fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}});
		}, 300))
	}
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations--single');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations--single', ProductRecommendations);

  // $(document).ready(function () {
  //   if ($('.product-section') && $('.product-section').length > 0) {

  //     // =====================================================================
  //     // FIX: Force eager loading on all carousel images BEFORE Flickity init
  //     // Lazy loading + Flickity = images don't load in hidden slides
  //     // =====================================================================
  //     document.querySelectorAll('.product-section .product__media-list img').forEach(function(img) {
  //       img.setAttribute('loading', 'eager');
  //     });

  //     document.querySelectorAll('.product-section .product__media-list').forEach((elem, index) => {
  //       var slider = new Flickity(elem, {
  //         pageDots: true,
  //         prevNextButtons: false,
  //         adaptiveHeight: true,
  //         wrapAround: true,
  //         imagesLoaded: true, // FIX: Wait for images before calculating slide dimensions
  //         on: {
  //           select: function (index) {
  //             let slides = $('.product-section .product__media-list .product__media-item');

  //             var iframe = $(slides[index]).find('iframe');

  //             var allIframes = document.querySelectorAll('.product-section .product__media-list iframe');
  //             var video = $(slides[index]).find('video');
  //             var allVideos = $('.product-section .product__media-list').find('video');

  //             if (video && video.length > 0) {
  //               video.get(0).play();
  //             } else if (allVideos && allVideos.length > 0) {
  //               allVideos.get(0).pause();
  //             }

  //             if (iframe && iframe.length > 0) {
  //               if (iframe[0].classList.contains('js-youtube')) {
  //                 iframe[0].contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo' }), '*');
  //               } else {
  //                 iframe[0].contentWindow.postMessage('{"method":"play"}', '*');
  //               }
  //             } else if (allIframes && allIframes.length > 0) {
  //               allIframes.forEach((video) => {
  //                 if (video.classList.contains('js-youtube')) {
  //                   video.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo' }), '*');
  //                 } else {
  //                   video.contentWindow.postMessage('{"method":"pause"}', '*');
  //                 }
  //               });
  //             } else {
  //               return false;
  //             }
  //           },
  //         },
  //       });

  //       elem.parentElement
  //         .querySelector('.product-section .product__media-list-wrapper-outer-arrow_prev')
  //         .addEventListener('click', function () {
  //           slider.previous();
  //         });
  //       elem.parentElement
  //         .querySelector('.product-section .product__media-list-wrapper-outer-arrow_next')
  //         .addEventListener('click', function () {
  //           slider.next();
  //         });
  //     });

  //     document.querySelectorAll('.product-section .product__media-sublist').forEach((elem, index) => {
  //       var cellCount = elem.querySelectorAll('.carousel-cell').length;
  //       var screenWidth = window.innerWidth;
  //       var showArrows = false;

  //       if (screenWidth > 1611) {
  //         showArrows = cellCount > 5;
  //       } else if (screenWidth > 1199) {
  //         showArrows = cellCount > 3;
  //       } else {
  //         showArrows = cellCount > 3;
  //       }

  //       var slider = new Flickity(elem, {
  //         asNavFor: document.querySelectorAll('.product-section .product__media-list')[index],
  //         contain: true,
  //         pageDots: true,
  //         prevNextButtons: showArrows,
  //         cellAlign: 'left',
  //         imagesLoaded: true, // FIX: Also apply to thumbnail sublist
  //       });
  //     });
  //   }
  // });
  document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector('.product-section')) return;

    // Thumbnail Swiper (left side vertical on desktop, horizontal on mobile)
    var thumbSwiper = new Swiper('.js-product-thumb-swiper', {
      direction: 'vertical',
      slidesPerView: 'auto',
      spaceBetween: 14,
      freeMode: false,
      centeredSlides: true,
      centeredSlidesBounds: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true, // aa add karo
      navigation: {
        prevEl: '.js-thumb-prev',
        nextEl: '.js-thumb-next',
      },
      breakpoints: {
        0: {
          direction: 'horizontal',
          centeredSlides: false, // false karo
          centeredSlidesBounds: false, // false karo
          slideToClickedSlide: true,
          navigation: { prevEl: null, nextEl: null },
        },
        992: {
          direction: 'vertical',
          centeredSlides: true,
          centeredSlidesBounds: true,
          slideToClickedSlide: true,
          navigation: {
            prevEl: '.js-thumb-prev',
            nextEl: '.js-thumb-next',
          },
        },
      },
    });

    // Main Swiper
    var mainSwiper = new Swiper('.js-product-main-swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      thumbs: {
        swiper: thumbSwiper,
      },
      on: {
        slideChange: function () {
          var idx = this.activeIndex;
          var slides = this.slides;

          // Pause previous slides
          slides.forEach(function (slide, i) {
            if (i !== idx) {
              var v = slide.querySelector('video');
              if (v) v.pause();
              var iframe = slide.querySelector('iframe');
              if (iframe) {
                if (iframe.classList.contains('js-youtube')) {
                  iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo' }), '*');
                } else {
                  iframe.contentWindow.postMessage('{"method":"pause"}', '*');
                }
              }
            }
          });

          // Play current slide
          setTimeout(function () {
            var cur = slides[idx];
            if (!cur) return;

            // Deferred media handle — load karo pehla
            var deferredMedia = cur.querySelector('deferred-media');
            if (deferredMedia && !deferredMedia.hasAttribute('loaded')) {
              // Poster button click simulate karo — Shopify deferred media load thase
              var posterBtn = deferredMedia.querySelector('.deferred-media__poster');
              if (posterBtn) posterBtn.click();
            }

            // Direct video (already loaded)
            setTimeout(function () {
              var v = cur.querySelector('video');
              if (v) {
                v.play();
                return;
              }
              var iframe = cur.querySelector('iframe');
              if (iframe) {
                if (iframe.classList.contains('js-youtube')) {
                  iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo' }), '*');
                } else {
                  iframe.contentWindow.postMessage('{"method":"play"}', '*');
                }
              }
            }, 300); // deferred media load thava mate thodi wait
          }, 100);
        },
      },
    });

    // Custom arrow buttons
    var prevBtn = document.querySelector('.js-main-prev');
    var nextBtn = document.querySelector('.js-main-next');
    if (prevBtn)
      prevBtn.addEventListener('click', function () {
        mainSwiper.slidePrev();
      });
    if (nextBtn)
      nextBtn.addEventListener('click', function () {
        mainSwiper.slideNext();
      });
    // SEE BEFORE & AFTER button
    // SEE BEFORE & AFTER button - cycle through all before-after slides
    var beforeAfterIndexes = [];
    var beforeAfterCounter = 0;

    document.querySelector('.action-btn.right-btn')?.addEventListener('click', function (e) {
      e.preventDefault();

      // Pehli click pehla — indexes collect karo
      if (beforeAfterIndexes.length === 0) {
        document.querySelectorAll('.js-product-main-swiper .swiper-slide').forEach(function (slide, index) {
          var alt = slide.dataset.alt || '';
          if (alt.includes('before-after')) {
            beforeAfterIndexes.push(index);
          }
        });
      }

      if (beforeAfterIndexes.length === 0) return; // koi before-after nathi

      // Current index par jao, pachhi next
      mainSwiper.slideTo(beforeAfterIndexes[beforeAfterCounter]);

      // Counter increment — end aave to reset
      beforeAfterCounter = (beforeAfterCounter + 1) % beforeAfterIndexes.length;
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    const mediaSublist = document.querySelector('.product__media-sublist');
    if (!mediaSublist) return;

    /* PREVIOUS arrow */
    const prevBtn = mediaSublist.querySelector('.flickity-prev-next-button.previous .flickity-button-icon');

    if (prevBtn) {
      prevBtn.outerHTML = `
      <svg class="flickity-button-icon" xmlns="http://www.w3.org/2000/svg" width="11" height="17" viewBox="0 0 11 17" fill="none">
        <path d="M11 6.53875L11 6.94197C9.75597 6.48533 8.64773 5.84063 7.74314 5.04736C6.83854 4.25409 6.15662 3.32893 5.73913 2.32852L5.73913 16.474L5.26087 16.474L5.26087 2.32852C4.84395 3.32959 4.16229 4.25546 3.25766 5.04938C2.35304 5.8433 1.24451 6.48856 -3.86428e-07 6.9456L-3.63792e-07 6.53875C1.58326 5.92124 2.91187 4.98429 3.83994 3.83079C4.76801 2.67729 5.25965 1.35184 5.26087 2.2996e-07L5.73913 2.50865e-07C5.74035 1.35184 6.23199 2.67729 7.16006 3.83079C8.08813 4.98429 9.41674 5.92124 11 6.53875Z" fill="black"/>
      </svg>
    `;
    }

    /* NEXT arrow */
    const nextBtn = mediaSublist.querySelector('.flickity-prev-next-button.next .flickity-button-icon');

    if (nextBtn) {
      nextBtn.outerHTML = `
      <svg class="flickity-button-icon" xmlns="http://www.w3.org/2000/svg" width="11" height="17" viewBox="0 0 11 17" fill="none">
        <path d="M-1.16152e-06 9.93586L-1.17434e-06 9.53264C1.24403 9.98928 2.35227 10.634 3.25686 11.4272C4.16146 12.2205 4.84338 13.1457 5.26087 14.1461L5.26087 0.000597251L5.73913 0.00059723L5.73913 14.1461C6.15605 13.145 6.83771 12.2192 7.74234 11.4252C8.64696 10.6313 9.75549 9.98605 11 9.52901L11 9.93586C9.41674 10.5534 8.08813 11.4903 7.16006 12.6438C6.23199 13.7973 5.74035 15.1228 5.73913 16.4746L5.26087 16.4746C5.25965 15.1228 4.76801 13.7973 3.83994 12.6438C2.91187 11.4903 1.58326 10.5534 -1.16152e-06 9.93586Z" fill="black"/>
      </svg>
    `;
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    var leftBtn = document.querySelector('.action-btn.left-btn');
    var modal = document.getElementById('pdp-video-modal');
    var videoEl = document.getElementById('pdp-popup-video');
    var closeBtn = document.getElementById('pdp-video-modal-close');
    var banner = document.querySelector('.pdp-video-modal-banner');

    if (leftBtn && modal && videoEl) {
      var videoUrl = leftBtn.getAttribute('data-video-url');
      if (!videoUrl) return;

      leftBtn.addEventListener('click', function (e) {
        e.preventDefault();
        videoEl.querySelector('source').setAttribute('src', videoUrl);
        videoEl.load();
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';

        // Banner show, video hide
        if (banner) banner.style.display = 'block';
        videoEl.style.display = 'none';

        // Video ready thay etle banner hide, video show
        videoEl.addEventListener('canplay', function onCanPlay() {
          if (banner) banner.style.display = 'none';
          videoEl.style.display = 'block';
          videoEl.play();
          videoEl.removeEventListener('canplay', onCanPlay);
        });
      });

      closeBtn.addEventListener('click', function () {
        modal.style.display = 'none';
        videoEl.pause();
        videoEl.currentTime = 0;
        document.body.style.overflow = '';
      });

      modal.addEventListener('click', function (e) {
        if (e.target === modal) {
          modal.style.display = 'none';
          videoEl.pause();
          videoEl.currentTime = 0;
          document.body.style.overflow = '';
        }
      });
    }

    const abBtn = document.querySelector('.a_b_btn');
    const abOverlay = document.getElementById('abPopupOverlay');
    const abClose = document.getElementById('abPopupClose');

    if (abBtn && abOverlay) {
      abBtn.addEventListener('click', () => {
        abOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      });

      abClose.addEventListener('click', () => {
        abOverlay.classList.remove('active');
        document.body.style.overflow = '';
      });

      abOverlay.addEventListener('click', (e) => {
        if (e.target === abOverlay) {
          abOverlay.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
